import { mq } from "@/constants/breakpoints";
import { blogCategoryPath } from "@/constants/paths";
import { css } from "@emotion/react";
import Link from "next/link";
import { Heading } from "../Typography";

interface BlogPageCategoriesProps {
  categories: any;
}

const BlogPageCategories = ({ categories }: BlogPageCategoriesProps) => {
  return (
    <div
      css={css`
        display: flex;
        gap: 12px;
      `}
    >
      {categories.map((category: any) => {
        return (
          <Link key={category.slug} href={blogCategoryPath(category.slug, 1)}>
            <Heading
              css={css`
                padding: 6px 13px;
                background: rgba(65, 66, 75, 0.2);
                border-radius: 47px;
                font-weight: 350;
                font-size: 12px;
                line-height: 14px;
                width: fit-content;
                color: #fff;
                border: 2px solid transparent;
                transition: border 0.2s ease-in-out;
                &:hover {
                  border: 2px solid #fff;
                }
                ${mq["lg"]} {
                  padding: 6px 16px;
                  font-size: 20px;
                  line-height: 130.02%;
                }
              `}
            >
              {category.category}
            </Heading>
          </Link>
        );
      })}
    </div>
  );
};

export default BlogPageCategories;
